// Fixes issue where inert is automatically added to autocomplete component
export async function removeInertFromLocationElement() {
    const autocompleteContainers = document.querySelectorAll('.pac-container[inert]');
    for (let i = 0; i < autocompleteContainers.length; i++) {
        autocompleteContainers.item(i)?.removeAttribute('inert');
    }
}

// Fixes vaadin inert bug
export async function removeInertFromVaadinOverlay(tag: string) {
    const body = document.querySelector('body');

    if (body) {
        const observer = new MutationObserver((mutationRecords, _) => {
            mutationRecords.map((m) => {
                m.addedNodes.forEach((n: any) => {
                    if (n.tagName === tag) {
                        const innerObserver = new MutationObserver((mutationRecords, _) => {
                            mutationRecords.map((m) => {
                                if (m.type === 'attributes' && m.attributeName === 'inert') {
                                    (m.target as Element).removeAttribute('inert');
                                }
                            });
                        });
                        innerObserver.observe(n, { attributes: true });
                    }
                });
            });
        });

        observer.observe(body, { childList: true });
    }
}